import { render, staticRenderFns } from "./Depenses.vue?vue&type=template&id=4cd460b6&scoped=true&"
import script from "./Depenses.js?vue&type=script&lang=js&"
export * from "./Depenses.js?vue&type=script&lang=js&"
import style0 from "./Depenses.vue?vue&type=style&index=0&id=4cd460b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd460b6",
  null
  
)

export default component.exports